import React, {
    Dispatch,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  bulkInvoiceRowsData,
  orderStatusConfig,
  bulkConfirmRowsData,
  DownloadSingleReportConfig,
  OrderType,
} from "../../types/types";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import {
  Alert,
  Button,
  Snackbar,
  TextField,
  FormControl,
  MenuItem,
  Tooltip,
  Select
} from "@mui/material";
import {
  generateBulkConfirm,
  getBulkConfirmStatus,
  getBulkOpertionData,
  getOrderListWithType,
  getUTCDate,
  updateOrderStatus,
} from "../../services/manageOrderService";
import "./Bulk.css";
import "../viewOrder/ViewOrder.css";
import "../manageBasket/ManageBasket.css";
import { Loader } from "../../components/loader/Loader";
import Header from "../../components/dms_common/Header";
import CustomDataGrid from "../../components/dms_common/CustomDataGrid";
import { createCatalogue } from "../../services/catalogueService";
import {
  getOrderSource,
  bulkConfirmColumnsMetaData,
  getDownloadSingleReportConfig,
} from "./ManageSecondaryOrderUtils";
import {
  filterData,
  getMultipleFilterBasedData,
  searchWithStatusFilter,
  updateDatesInLocalStorage,
} from "../../components/dms_common/DmsCommonServices";
import {
  isGapMoreThanNDays,
  isStartDateIsGreaterThanEndDate,
} from "../../utils/calenderUtils";
import { getConfigData } from "../../services/configurationService";

import {
  createSkuWiseStockMap,
  GenericModal,
  getBatchCodes,
  getGenericModalProps,
  initialGenericModalProps,
} from "../viewOrder/ViewOrderUtils";

import {
  BulkStatus,
  determineBulkStatus,
  initialBulkStatusMap,
  showProgressInitialState,
} from "./BulkUtils";
import { getAccessToken } from "../../services/authenticationService";
import ScreenOverlay from "../../components/dms_common/ScreenOverlay";
import useSessionStorageDates from "../../components/dms_common/UseSessionStorageDates";
import BulkProgress from "./BulkProgress";
import { setRealTimeStockDataInDb } from "../stocks/RealTimeStock/RealTimeStockUtils";
import { CustomBulkModal } from "../../components/dms_common/CustomBulkModal";
import { analytics, logLoadTrace, performance } from "../../../src/firebase";
import { logEvent } from "firebase/analytics";
import { PerformanceTrace, trace } from "firebase/performance";
import { getDataFromLocalDb } from "../../services/dbService";
import { containerClasses } from "@mui/joy";
import { getQuantityType, truncateString } from "../../components/dms_common/DmsUtils";
import { string } from "yup";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import { capitalizeFirstLetter } from "../../utils/utils";

type BulkConfirmProps = {
  pending_data?: bulkConfirmRowsData[],
  startDateV?: Dayjs,
  endDateV?: Dayjs
  handleToggle?: () => void,
  disableStockCheck?: boolean,
  useNewUpdateStatusAPI?: boolean,
  multipleCategoryFilterEnabled?: boolean
}

type OrderNumberBatchCodesMapType = {
  [key: string]: string
}

export type BulkOrderMapType = {
  inProgress: string[],
  confirmed: string[],
  partiallyConfirmed: string[],
  rejected: string[],
  failed: string[],
  invoiced: string[]
  partiallyInvoiced?: string[]
}

export let orderStatusMap: BulkOrderMapType = {
  inProgress: [],
  confirmed: [],
  partiallyConfirmed: [],
  rejected: [],
  failed: [],
  invoiced: [],
  partiallyInvoiced: [],
};

export type BulkConfirmConfigType = {
  preFooterLabel: string;
  postFooterLabel: string;
  pageHeadingLabel: string;
}

export let defaultBulkConfirmLabels: BulkConfirmConfigType = {
  preFooterLabel: "Bulk Confirm",
  postFooterLabel: "Confirm Orders",
  pageHeadingLabel: "Bulk Confirm"
}

const BulkConfirm = ({ pending_data, startDateV, endDateV, handleToggle, disableStockCheck, useNewUpdateStatusAPI, multipleCategoryFilterEnabled }: BulkConfirmProps) => {

  let { storedStartDate, storedEndDate, storeSessionStorageDates } = useSessionStorageDates("bulkConfirm")
  storedEndDate = endDateV ? endDateV : storedEndDate;
  storedStartDate = startDateV ? startDateV : storedStartDate;

  const [isBulkStillProcessing, setIsBulkStillProcessing] = useState<boolean>(true);
  const [bulkId, setBulkId] = useState<string | undefined>(undefined);
  const [orderBulkStatusMap, setOrderBulkStatusMap] = useState<BulkOrderMapType>(orderStatusMap);

  const [data, setData] = useState<bulkConfirmRowsData[]>(pending_data ? pending_data : []);
  const [rows, setRows] = useState<bulkConfirmRowsData[]>(pending_data ? pending_data : []);
  const [confirmableOrders, setConfirmableOrders] = useState<bulkConfirmRowsData[]>([]);
  const [partiallyConfirmableOrders, setPartiallyConfirmableOrders] = useState<bulkConfirmRowsData[]>([]);
  const [unavailableOrders, setUnavailableOrders] = useState<bulkConfirmRowsData[]>([]);
  const [orderTrackingStagesList, setOrderTrackingStagesList] = useState<
    orderStatusConfig[]
  >([]);
  const [startDate, setStartDate] = useState<Dayjs>(storedStartDate);
  const [endDate, setEndDate] = useState<Dayjs>(storedEndDate);
  const [loader, setLoader] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const allOrdersReportIdRef = useRef<string | null>(null);
  const singleOrderReportIdRef = useRef<string | null>(null);
  const [searchedValue, setSearchedValue] = useState<string>("");
  const [checkedOrderNumbers, setCheckedOrderNumbers] = useState<string[]>([]);
  const [disableRowIds, setDisableRowIds] = useState<string[]>([]);
  const [genericModalProps, setGenericModalProps] = useState<GenericModal>(
    initialGenericModalProps
  );
  const routeIdNameMappingRef = useRef<any>({});
  const [bulkConfirmStatusMap, setBulkConfirmStatusMap] =
    useState<BulkStatus>(initialBulkStatusMap);
  const [showProgress, setShowProgress] = useState<any>(
    showProgressInitialState
  );
  const [nonSelectableOrderNumbers, setNonSelectableOrderNumbers] = useState<
    string[]
  >([]);

  const [downloadSingleReportConfig, setDownloadSingleReportConfig] =
    useState<DownloadSingleReportConfig | null>();
  const [orderNumbers, setOrderNumbers] = useState<string []>([])
  const [resetSearch, setResetSearch] = useState(false);
  const [orderNumberBatchCodesMap, setOrderNumberBatchCodesMap] = useState<OrderNumberBatchCodesMapType>();
  const [bulkConfirmLabelConfig, setBulkConfirmLabelConfig] = useState<BulkConfirmConfigType>(defaultBulkConfirmLabels);
  const confirmPayloadStatus = useRef<string>("CONFIRMED");
  const disableViewOrderForAll = useRef<boolean>(false);
  const showFilterInBulkConfirm = useRef<boolean>(false);

  const orderTypeFilterForBulkSync = useRef<string[]>(["PENDING"]);
  const [multipleFiltersVisible, setMultipleFiltersVisible] =
    useState<boolean>(false);

  const [filterKeys, setFilterKeys] = useState<string[]>([]); 

  const [statusFilter, setStatusFilter] = useState<string>("ALL");
  const [selectedFilterType, setSelectedFilterType] = useState("status");
    
  const [filterSearchValue, setFilterSearchValue] = useState<string>("");
  const [selectedFilters, setSelectedFilters] = useState<Record<string, string[]>>(() => {
    const stored = localStorage.getItem('multipleFiltersListManageOrders');
    return stored ? JSON.parse(stored) : {};
  });

  const [multipleFiltersList, setMultipleFiltersList] = useState<
    Record<string, Record<string, number>>
  >({});

  const feature = "Sale";
  const pageID = "ManageOrder";
  const bulkType = "confirm";

  const disableStockCheckBool = disableStockCheck && disableStockCheck;

  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
  const { uomConversion, showStatusReasonColumnBulkConfirm, useKafkaBulkFlow } = ConfigDictionary;
  const validDateRange = ConfigDictionary.dateRangeConfig ?? 31;
  function canWeMakeRequest() {
    if (startDate && endDate && isGapMoreThanNDays(startDate, endDate, validDateRange)) {
      setGenericModalProps(
        getGenericModalProps("positive", `You can't select date range more than ${validDateRange} days!`)
      );
      return false;
    }
    if (
      startDate &&
      endDate &&
      isStartDateIsGreaterThanEndDate(startDate, endDate)
    ) {
      setGenericModalProps(
        getGenericModalProps("positive", "To Date should be greater than from date.")
      );
      return false;
    }
    updateDatesInLocalStorage(startDate, endDate, feature, pageID);
    return true;
  }


  const handleApplyLog = async (nonSelectableSentOrderNumbers?: string[]) => {
    logLoadTrace(
        () => handleApply(nonSelectableSentOrderNumbers),
        "manage_secondary_order_bulk_confirm_page_load_time"
      );
    };

  const handleApply = async (nonSelectableSentOrderNumbers?: string[]) => {
    if (canWeMakeRequest()) {
      storeSessionStorageDates(startDate, endDate)
      const start = getUTCDate(startDate, "start");
      const end = getUTCDate(endDate, "end");
      await getAllOrderData(start, end, nonSelectableSentOrderNumbers);
      setOrderBulkStatusMap(orderStatusMap);
      setBulkId(undefined);
      setIsBulkStillProcessing(true);
      setLoader(false);
    }
  };

  const handleClearAllLog = async() => {
      logLoadTrace(handleClearAll,"manage_secondary_order_bulk_confirm_page_load_time");
  }

  const handleClearAll = async () => {
    const date = dayjs();
    storeSessionStorageDates(date, date)
    const start = getUTCDate(date, "start");
    const end = getUTCDate(date, "end");
    setStartDate(date);
    setEndDate(date);
    await getAllOrderData(start, end);
  };

  const getAllOrderData = async (startDate: string, endDate: string, nonSelectableSentOrderNumbers?: string[]) => {
    let copiedSendRows: bulkConfirmRowsData[] = [];
    if(nonSelectableSentOrderNumbers && nonSelectableSentOrderNumbers?.length > 0) {
      copiedSendRows = rows?.filter(s => nonSelectableSentOrderNumbers?.includes(s.orderNumber));
      copiedSendRows?.forEach(s => s.status = confirmPayloadStatus.current);
    }
    reset()
    setRows([]);
    setData([]);
    try {
      let pageNumber = 0;
      let hasMoreData = true;
      setLoader(true);
      
      const routeIdNameMapping = routeIdNameMappingRef.current;
      let responseArray: bulkInvoiceRowsData[] = [];
      const orderTypes = orderTypeFilterForBulkSync.current.join(",")
      while (hasMoreData){
        const response = await getOrderListWithType(
          startDate,
          endDate,
          "secondary,VisitOrder,subd",
          orderTypes,
          true,
          true,
          pageNumber,
          true
        );
        if (response?.data?.features?.length > 0) {
          hasMoreData = response?.data?.features?.length < 1000 ? false : true;
          response?.data?.features?.forEach((item: any, index: any) => {
            const {
              id,
              outletName,
              outletCode,
              creationTime,
              totalCaseQuantity,
              totalPieceQuantity,
              totalOtherUnitQuantity,
              netAmount,
              status,
              orderNumber,
              salesRepName,
              salesRepId,
              orderDetails,
            } = item || {};

            const extraParams = status === "INVOICED" ? `?type=invoice` : ``;
            const orderSource = getOrderSource(item);
            const routeId = item?.beat ?? item?.extendedAttributes?.beat ?? ""
              const routeName = (ConfigDictionary.fetchPricingBySalesrep) ? (routeIdNameMapping?.[routeId]?.filter1 ?? "-") : (item?.beatName ?? "-");
              const routeIdAndName = routeId ? (routeIdNameMapping?.[routeId]?.filter1 ? `${routeId}-${routeIdNameMapping[routeId].filter1}` : routeId) : "";
            const statusReason = item?.statusReason ?? "";

            const locationId = typeof routeId === "string" && routeId.length >= 2
              ? routeId.slice(0, 2)
              : routeId ?? "";

            responseArray.push({
              id: orderNumber,
              statusReason,
              orderId: id,
              outletName,
              outletCode,
              routeName,
              creationTime,
              totalCaseQuantity,
              totalPieceQuantity,
              totalOtherUnitQuantity,
              netAmount: netAmount,
              status: status
                .toLowerCase()
                .replace(/(?:^|\s|&)\S/g, (match: any) => match?.toUpperCase()),
              orderNumber,
              source: orderSource,
              extraParams,
              salesRepName,
              salesRepId,
              "orderDetails": orderDetails,
              routeId,
              locationId,
            });
          });
        } else {
          hasMoreData = false;
          // setRows([]);
          // setData([]);
        }
        pageNumber += 1;
      }

      if(disableViewOrderForAll.current) {
        setDisableRowIds([...disableRowIds, ...responseArray?.flatMap(rs => rs?.id)])
      }
      if(nonSelectableSentOrderNumbers && nonSelectableSentOrderNumbers?.length > 0) {
        setRows([...responseArray, ...copiedSendRows]);
        setData([...responseArray, ...copiedSendRows]);
      } else {
        setRows(responseArray);
        setData(responseArray);
      }
      setSearchedValue("");
    } catch (error) {
      setRows([]);
      setGenericModalProps(
        getGenericModalProps("error", "Something went wrong")
      );
    } finally {
      setLoader(false);
    }
  };

  const handleSearchValueChange = (newValue: string) => {
    setSearchedValue(newValue);
  };

  const handleSnackbarClose = (
    _event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const getInitalTableData = async () => {
    const start = getUTCDate(startDate, "start");
    const end = getUTCDate(endDate, "end");
    await getAllOrderData(start, end);
  };


  const fetchRequiredConfigs = async () => {
    try {
      const orderTrackingStages = await getConfigData(
        "order_configuration",
        "orderTrackingStages"
      );
      const allOrdersReportId = await getConfigData(
        "dms_configuration",
        "orderReportId"
      );
      const orderBulkConfirmationLabelConfig = await getConfigData(
        "dms_configuration",
        "bulkOrderConfirmationLabel"
      );
      const confirmPayloadStatusConfig = await getConfigData(
        "dms_configuration",
        "confirmPayloadStatus"
      );
      const orderTypeFilterForBulkSyncConfig = await getConfigData(
        "dms_configuration",
        "orderTypeFilterForBulkSync"
      );

      const showFilterInBulkConfirmConfig = await getConfigData(
        "dms_configuration",
        "showFilterInBulkConfirm"
      );
      const dbResult = await getDataFromLocalDb("RouteNameIdMapping");
      routeIdNameMappingRef.current = dbResult?.data?.[0]?.data ?? {};
      const filterKeysConfig = await getConfigData("dms_configuration","multiFilterKeysBulkConfirm");
      setFilterKeys(filterKeysConfig[0]?.configValue ?? ["salesRepName"]);

      const res11 = await getConfigData("order_configuration", "disableViewOrderForAll")
      disableViewOrderForAll.current = res11[0]?.configValue ?? disableViewOrderForAll.current;
      setBulkConfirmLabelConfig(orderBulkConfirmationLabelConfig[0]?.configValue ?? defaultBulkConfirmLabels);

      orderTypeFilterForBulkSync.current = orderTypeFilterForBulkSyncConfig[0]?.configValue ?? ["PENDING"];
      showFilterInBulkConfirm.current = showFilterInBulkConfirmConfig[0]?.configValue ?? false;
      
      confirmPayloadStatus.current = confirmPayloadStatusConfig[0]?.configValue ?? confirmPayloadStatus.current;
      const orderReportId = allOrdersReportId[0]?.configValue ?? "";
      const secondaryOrderReportId = allOrdersReportId[0]?.configValue ?? "";
      allOrdersReportIdRef.current = secondaryOrderReportId;
      singleOrderReportIdRef.current = secondaryOrderReportId;
      setOrderTrackingStagesList(orderTrackingStages[0]?.configValue ?? []);
      setDownloadSingleReportConfig(
        getDownloadSingleReportConfig(orderReportId)
      );
    } catch (e) {
      console.error("Error while fetching configs", e);
      setGenericModalProps(
        getGenericModalProps("error", "Error while fetching configs")
      );
    }
  };
  const handleFilterSearchValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterSearchValue(e.target.value);
    logEvent(analytics, "secondary_order_filter_applied", {
      "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
      "filter_type": e.target.value,
    });
    e.stopPropagation();
  };
  const handleFilterTypeChange = (type: string) => {
    setSelectedFilterType(type);
    setFilterSearchValue("");
  };


  useEffect(() => {
    if(multipleCategoryFilterEnabled) {
      // Check if filters were cleared and refresh data if needed
      const hasAnyFilters = Object.values(selectedFilters).some(arr => arr.length > 0);
      
      if ( !hasAnyFilters && statusFilter !== "ALL") {
        setStatusFilter("ALL");
      }
    }
  }, [selectedFilters, statusFilter]);
  

  function getFilterLabel(key: string): string {
    switch (key) {
      case "salesRepName":
        return "SalesRep";
      case "routeIdAndName":
        return "Route";
      case "routeId":
        return "Route ID";
      case "gstNo":
        return "GST Type";
      case "locationId":
        return "Location";
      default:
        return capitalizeFirstLetter(key);
    }
  }

  const handleSelectedFilterChange = (key: string, value: string) => {
    setSelectedFilters((prev) => {
      const current = prev[key] || [];
      const newFilters = {
        ...prev,
        [key]: current.includes(value)
          ? current.filter((v) => v !== value)
          : [...current, value],
      };
      
      // Check if this was the last filter being deselected
      const hasAnyFilters = Object.values(newFilters).some(arr => arr.length > 0);
      
      if (!hasAnyFilters) {
        // Use setTimeout to avoid state update conflicts
        setTimeout(() => {
          setStatusFilter("ALL");
        }, 0);
      }
      
      return newFilters;
    });
  };

  useEffect(() => {
    const counts: Record<string, Record<string, number>> = {};
    filterKeys.forEach((key) => {
      counts[key] = {};
    });

    if (filterKeys.includes("status")) {
      const labelToIdMap = new Map<string, string>();
      let allDmsLabel: string | undefined;
      orderTrackingStagesList.forEach((stage) => {
        if (stage?.dmsLabel && stage?.id) {
          labelToIdMap.set(stage.dmsLabel.toUpperCase(), stage.id);
          if (stage.id === "ALL") {
            allDmsLabel = stage.dmsLabel.toUpperCase();
          }
        }
      });

      orderTrackingStagesList.forEach((stage: any) => {
        if (stage?.dmsLabel && stage.dmsLabel.toUpperCase() !== allDmsLabel) {
          counts["status"][stage.dmsLabel.toUpperCase()] = 0;
        }
      });

      data.forEach((row: any) => {
        const rowStatus = row?.status?.toUpperCase();
        Object.keys(counts["status"]).forEach((key) => {
          const labels = labelToIdMap.get(key)?.split(',').map((label) => label.trim()) ?? [];
          if (labels.includes(rowStatus)) {
            counts["status"][key] += 1;
          }
        });
      });
    }

    filterKeys.filter((key) => key !== "status").forEach((key) => {
      data.forEach((row: any) => {
        const value = row[key];
        if ( typeof value === "string" && value) {
          counts[key][value.toLowerCase()] = (counts[key][value.toLowerCase()] || 0) + 1;
        }
      });
    });

    setMultipleFiltersList(counts);
  }, [orderTrackingStagesList, data, filterKeys]);


    const filteredData = useMemo(() => {
      const labelToIdMap = new Map<string, string>();
  
      orderTrackingStagesList.forEach((stage) => {
        if (stage?.dmsLabel && stage?.id) {
          labelToIdMap.set(stage.dmsLabel.toUpperCase(), stage.id);
        }
      });
  
      // If user has manually changed filters and we have selectedFilters, use those
      // Otherwise fall back to statusFilter for backward compatibility
      const hasUserSelectedFilters = Object.keys(selectedFilters).length > 0 &&
        Object.values(selectedFilters).some(arr => arr.length > 0);
  
      let finalFilteredData = data;
  
      if (multipleCategoryFilterEnabled && hasUserSelectedFilters) {
        // Use multiple filter approach when user has selected specific filters
        const updatedSelectedFilters = { ...selectedFilters };
  
        // Convert status labels to IDs if needed
        if (filterKeys.includes("status") && selectedFilters["status"]) {
          let statuses: string[] = [];
          selectedFilters["status"].forEach((status) => {
            statuses = [...statuses, ...labelToIdMap.get(status.toUpperCase())?.split(',').map((label) => label.trim()) ?? []];
          });
          updatedSelectedFilters["status"] = statuses;
        }
  
        finalFilteredData = getMultipleFilterBasedData(data, updatedSelectedFilters, filterKeys);
      } else {
        // Fall back to original statusFilter approach for backward compatibility
        finalFilteredData = data;
      }
  
      // Apply search filtering
      const searchFilteredData = filterData(
        finalFilteredData,
        searchedValue?.toLowerCase(),
        searchWithStatusFilter,
        hasUserSelectedFilters ? "ALL" : statusFilter
      );
  
      let filteredResults = searchFilteredData;
  
      if (multipleCategoryFilterEnabled && hasUserSelectedFilters) {
        // Find intersection for multiple filters
        filteredResults = finalFilteredData.filter((item: any) =>
          new Set(searchFilteredData).has(item)
        );
      }
  
      if (searchedValue?.length !== 0) {
        logEvent(analytics, "search_secondary_order", {
          "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
          "search_query": searchedValue,
          "result_count": filteredResults?.length ?? 0,
        });
      }
  
      if (hasUserSelectedFilters) {
        logEvent(analytics, "search_secondary_order", {
          "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
          "filter_type": "multiple_filters_applied",
        });
      } else if (statusFilter !== "ALL") {
        logEvent(analytics, "search_secondary_order", {
          "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
          "filter_type": statusFilter,
        });
      }
  
      return filteredResults;
    }, [
      searchedValue,
      statusFilter,
      data,
      selectedFilters,
      filterKeys,
    ]);
  
    useEffect(() => {
      setRows(filteredData);
    }, [filteredData]);

  const init = async () => {
    setLoader(true);
    // await Promise.allSettled([fetchRequiredConfigs(), getInitalTableData()])
    // Await fetchRequiredConfigs to set the statusFilters before running getInitalTableData
    await fetchRequiredConfigs().then(() => {
      return getInitalTableData();
    });
  };

  useEffect(() => {
    if(!disableStockCheckBool) fetchStockData();
  }, [checkedOrderNumbers]); // Added fetchStockData as a dependency


  useEffect(() => {
    logLoadTrace(init,"manage_secondary_order_bulk_confirm_page_load_time");
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if(isBulkStillProcessing && (useKafkaBulkFlow && useKafkaBulkFlow)) {
        handleUpdateBulkStatus(bulkId);
      }
    }, 1000);

    // Cleanup to avoid memory leaks
    return () => clearInterval(intervalId);
  }, [isBulkStillProcessing, bulkId]);

  useEffect(() => {
    const updateProgressbar = () => {
      let pending: string[] = [];
      let rejected: string[] = [];
      let failed: string[] = [];
      let confirmed: string[] = [];
      let partiallyConfirmed: string[] = [];

      for (const ro of data) {
        let orderNumber: string = ro?.orderNumber;
        if (orderBulkStatusMap.inProgress.includes(orderNumber)) {
          pending.push(orderNumber);
        } else if (orderBulkStatusMap.rejected.includes(orderNumber)) {
          rejected.push(orderNumber);
        } else if (orderBulkStatusMap.failed.includes(orderNumber)) {
          failed.push(orderNumber);
        } else if (orderBulkStatusMap.confirmed.includes(orderNumber)) {
          confirmed.push(orderNumber);
        } else if (orderBulkStatusMap.partiallyConfirmed.includes(orderNumber)) {
          partiallyConfirmed.push(orderNumber);
        }
      }
      if(pending.length + rejected.length + failed.length + confirmed.length + partiallyConfirmed.length > 0) {
        setNonSelectableOrderNumbers((prev: string[]) => [...prev, ...rejected, ...confirmed, ...partiallyConfirmed])
        setBulkConfirmStatusMap((prev: BulkStatus) => ({
          ...prev,
          pending: [...pending],
          pass: [...prev.pass, ...confirmed],
          fail: [...prev.fail, ...failed],
          partial: [...prev.partial, ...partiallyConfirmed],
        }));
      }
    }
    updateProgressbar();
  }, [orderBulkStatusMap])

  const handleSetCheckedIdArray = (ids: any[]) => {
    const updatedIds = [...ids]?.filter(
      (id: string) => !nonSelectableOrderNumbers?.includes(id)
    );
    setCheckedOrderNumbers(updatedIds);
  };

    const handleClickConfirm = async () => {
      if (!checkedOrderNumbers || checkedOrderNumbers.length === 0) {
        setGenericModalProps(
          getGenericModalProps("positive", "Please select at least one order to confirm order.")
        );
        return;
      }
      if(disableStockCheck && disableStockCheck) {
        (useKafkaBulkFlow && useKafkaBulkFlow && checkedOrderNumbers?.length > 5) ? await handleBulkConfirmingNewApproach() : await handleBulkConfirming();
        return;
      }

    const updatedGenericModalProps = getGenericModalProps(
      "positive",
      "Review the Bulk confirmation of the selected pending order:",
      "Continue",
      "Cancel",
      () => {
        (useKafkaBulkFlow && useKafkaBulkFlow && checkedOrderNumbers?.length > 5) ? handleBulkConfirmingNewApproach() : handleBulkConfirming()
        resetGenericModalProps()
      },
      () => resetGenericModalProps(),
    );
    setGenericModalProps(updatedGenericModalProps);
  };

  const fetchStockData = async () => {
    if(checkedOrderNumbers?.length < 1) return;
    // Start a custom trace for view secondary order page load time
    const pageLoadTrace: PerformanceTrace = trace(performance, "manage_secondary_order_bulk_confirm_page_stock_load_time");
    pageLoadTrace.start();
    let allBatchCodesSet: Set<string> = new Set(); // Use a Set to store unique batch codes
    let batchCodeMap: OrderNumberBatchCodesMapType = {};
    let selectedOrderData: bulkConfirmRowsData[] = [];

    for (const ro of data) {
      const orderedBatchCodes: string = getBatchCodes(ro["orderDetails"] ?? "") ?? "";
      const orderNumber = ro.orderNumber;

      if (!checkedOrderNumbers.includes(orderNumber)) continue;
      selectedOrderData.push(ro);
      batchCodeMap[orderNumber] = orderedBatchCodes;

      // Split batch codes and add to the Set to ensure uniqueness
      const codesArray = orderedBatchCodes.split(",").map(code => code.trim()).filter(Boolean);
      codesArray.forEach(code => allBatchCodesSet.add(code));
    }

    let allBatchCodes = Array.from(allBatchCodesSet).join(",");

    if(allBatchCodes?.length === 0) return;

    const BATCH_SIZE = 100;
    const allBatchCodesArray = allBatchCodes.split(",").map(code => code.trim()).filter(Boolean);

    let stocksData: any[] = [];

    for (let i = 0; i < allBatchCodesArray?.length; i += BATCH_SIZE) {
      const chunk = allBatchCodesArray.slice(i, i + BATCH_SIZE);
      const chunkString = chunk.join(",");
      
      const chunkStockData = await setRealTimeStockDataInDb(chunkString, getQuantityType());
      stocksData = stocksData.concat(chunkStockData);
    }

    let stocksDataResult = await createSkuWiseStockMap(stocksData);
    let stockBatchWiseMap = getBatchCodeQuantities(allBatchCodes, stocksDataResult);
    setOrderNumberBatchCodesMap(batchCodeMap);
    const dbResult = await getDataFromLocalDb("Product");
    const products: any = dbResult?.data?.[0]?.data ?? {};
    let confOrders: bulkConfirmRowsData[] = [];
    let parOrders: bulkConfirmRowsData[] = [];
    let canOrders: bulkConfirmRowsData[] = [];

    // First, let's calculate normalized quantities for the stockBatchWiseMap
    const normalizedStockMap = new Map<string, number>();

    // Preprocess the stock data to include normalized quantities
    if (uomConversion) {
      // Convert Map entries to array for compatibility with older ES versions
      const stockBatchWiseEntries: Array<[string, [number, number, number]]> = [];
      stockBatchWiseMap.forEach((value, key) => {
        stockBatchWiseEntries.push([key, value]);
      });
      
      for (let i = 0; i < stockBatchWiseEntries.length; i++) {
        const [batchCode, quantities] = stockBatchWiseEntries[i];
        const product = products[batchCode];
        if (product) {
          const [avCs, avPi, avOth] = quantities;
          // Calculate normalized quantity based on product conversion factors
          const stockNormalizedQty = 
            avCs * (product?.caseToPieceQuantity ?? 0) + 
            avOth * (product?.otherUnitToPieceQuantity ?? 0) + 
            avPi;
          
          // Store the normalized quantity for this batch code
          normalizedStockMap.set(batchCode, stockNormalizedQty);
        }
      }
    }

    // Process each order
    for (const ro of selectedOrderData.sort((a, b) => new Date(a.creationTime).getTime() - new Date(b.creationTime).getTime())) {
      let canFulfillCompletely = true;
      let canFulfillPartially = false;
      let hasAnyUnfulfillableItems = false;
      let unFulFillableItems: number = 0;
      
      // Deep clone the stockBatchWiseMap
      const tempStockMap = new Map<string, [number, number, number]>();
      stockBatchWiseMap.forEach((value, key) => {
        tempStockMap.set(key, [...value]);
      });
      
      // Clone the normalizedStockMap
      const tempNormalizedStockMap = new Map<string, number>();
      normalizedStockMap.forEach((value, key) => {
        tempNormalizedStockMap.set(key, value);
      });
      
      // Check availability for all items in this order
      for (const roo of ro["orderDetails"]) {
        let caseOQ = roo?.caseQuantity ?? 0;
        let pieceOQ = roo?.pieceQuantity ?? 0;
        let otherUnitOQ = roo?.otherUnitQuantity ?? 0;
        let batchCode = roo?.batchCode ?? "";
        
        let product = products[batchCode];
        
        if (uomConversion && product) {
          // Get or calculate normalized order quantity
          let orderDetailsNQ = roo?.normalizedQuantity ?? (
            caseOQ * (product?.caseToPieceQuantity ?? 0) + 
            otherUnitOQ * (product?.otherUnitToPieceQuantity ?? 0) + 
            pieceOQ
          );
          
          // Get normalized stock quantity
          let stockNQ = tempNormalizedStockMap.get(batchCode) ?? 0;
          
          if (stockNQ === 0) {
            canFulfillCompletely = false;
            
            // If we need items from this batch and there's no stock for this item
            if (orderDetailsNQ > 0) {
              unFulFillableItems++;
              // Don't break here, continue checking other items
            }
          } else if (stockNQ >= orderDetailsNQ) {
            // We can fulfill this item completely
            // If we have any items with stock, we can at least partially fulfill the order
            if (orderDetailsNQ > 0) {
              canFulfillPartially = true;
            }
          } else {
            // We can only partially fulfill this item
            canFulfillCompletely = false;
            
            // If there's any stock available and we need this item, we can partially fulfill
            if (orderDetailsNQ > 0 && stockNQ > 0) {
              canFulfillPartially = true;
            }
          }
        } else {
          // Original non-conversion logic
          let [avCs, avPi, avOth] = tempStockMap.has(batchCode) 
            ? (tempStockMap.get(batchCode) ?? [0, 0, 0]) 
            : [0, 0, 0];
          
          // Check if there's no stock at all for this batch code
          if (avCs === 0 && avPi === 0 && avOth === 0) {
            canFulfillCompletely = false;
            
            if (caseOQ > 0 || pieceOQ > 0 || otherUnitOQ > 0) {
              unFulFillableItems++;
              // Don't break here, continue checking other items
            }
          } else if (avCs >= caseOQ && avPi >= pieceOQ && avOth >= otherUnitOQ) {
            // We can fulfill this item completely
            // If we have any items with stock, we can at least partially fulfill the order
            if (caseOQ > 0 || pieceOQ > 0 || otherUnitOQ > 0) {
              canFulfillPartially = true;
            }
          } else {
            canFulfillCompletely = false;
            
            if ((caseOQ > 0 && avCs > 0) || (pieceOQ > 0 && avPi > 0) || (otherUnitOQ > 0 && avOth > 0)) {
              canFulfillPartially = true;
            }
          }
        }
      }

      hasAnyUnfulfillableItems = !(unFulFillableItems === ro["orderDetails"]?.length);
      
      // Categorize the order based on our findings
      if (canFulfillCompletely) {
        // Handle complete fulfillment
        if (uomConversion) {
          for (const roo of ro["orderDetails"]) {
            let caseOQ = roo?.caseQuantity ?? 0;
            let pieceOQ = roo?.pieceQuantity ?? 0;
            let otherUnitOQ = roo?.otherUnitQuantity ?? 0;
            let batchCode = roo?.batchCode ?? "";
            let product = products[batchCode];
            
            if (product && normalizedStockMap.has(batchCode)) {
              // Calculate normalized order quantity
              let orderDetailsNQ = roo?.normalizedQuantity ?? (
                caseOQ * (product?.caseToPieceQuantity ?? 0) + 
                otherUnitOQ * (product?.otherUnitToPieceQuantity ?? 0) + 
                pieceOQ
              );
              
              // Deduct from normalized stock
              let currentNQ = normalizedStockMap.get(batchCode) ?? 0;
              normalizedStockMap.set(batchCode, currentNQ - orderDetailsNQ);
              
              // Also update the original stock map
              if (stockBatchWiseMap.has(batchCode)) {
                let [avCs, avPi, avOth] = stockBatchWiseMap.get(batchCode) ?? [0, 0, 0];
                stockBatchWiseMap.set(batchCode, [
                  Math.max(0, avCs - caseOQ), 
                  Math.max(0, avPi - pieceOQ), 
                  Math.max(0, avOth - otherUnitOQ)
                ]);
              }
            }
          }
        } else {
          // Original non-conversion logic for complete fulfillment
          for (const roo of ro["orderDetails"]) {
            let caseOQ = roo?.caseQuantity ?? 0;
            let pieceOQ = roo?.pieceQuantity ?? 0;
            let otherUnitOQ = roo?.otherUnitQuantity ?? 0;
            let batchCode = roo?.batchCode ?? "";
            
            if (stockBatchWiseMap.has(batchCode)) {
              let [avCs, avPi, avOth] = stockBatchWiseMap.get(batchCode) ?? [0, 0, 0];
              stockBatchWiseMap.set(batchCode, [avCs - caseOQ, avPi - pieceOQ, avOth - otherUnitOQ]);
            }
          }
        }
        confOrders.push(ro);
      } else if (canFulfillPartially || (!canFulfillPartially && hasAnyUnfulfillableItems)) {
        // Handle partial fulfillment - even if some items have zero stock
        if (uomConversion) {
          for (const roo of ro["orderDetails"]) {
            let caseOQ = roo?.caseQuantity ?? 0;
            let pieceOQ = roo?.pieceQuantity ?? 0;
            let otherUnitOQ = roo?.otherUnitQuantity ?? 0;
            let batchCode = roo?.batchCode ?? "";
            let product = products[batchCode];
            
            if (product && normalizedStockMap.has(batchCode)) {
              // Calculate normalized order quantity
              let orderDetailsNQ = roo?.normalizedQuantity ?? (
                caseOQ * (product?.caseToPieceQuantity ?? 0) + 
                otherUnitOQ * (product?.otherUnitToPieceQuantity ?? 0) + 
                pieceOQ
              );
              
              // Get available normalized stock
              let availableNQ = normalizedStockMap.get(batchCode) ?? 0;
              
              // Determine how much we can fulfill
              let fulfillableNQ = Math.min(availableNQ, orderDetailsNQ);
              
              if (fulfillableNQ > 0) {
                // Deduct from normalized stock
                normalizedStockMap.set(batchCode, availableNQ - fulfillableNQ);
                
                // Determine how to distribute the fulfillment across units
                if (stockBatchWiseMap.has(batchCode)) {
                  let [avCs, avPi, avOth] = stockBatchWiseMap.get(batchCode) ?? [0, 0, 0];
                  
                  // Deduct only what we can fulfill for each unit type
                  let deductCs = Math.min(avCs, caseOQ);
                  let deductPi = Math.min(avPi, pieceOQ);
                  let deductOth = Math.min(avOth, otherUnitOQ);
                  
                  stockBatchWiseMap.set(batchCode, [
                    avCs - deductCs, 
                    avPi - deductPi, 
                    avOth - deductOth
                  ]);
                }
              }
            }
          }
        } else {
          // Original non-conversion logic for partial fulfillment
          for (const roo of ro["orderDetails"]) {
            let caseOQ = roo?.caseQuantity ?? 0;
            let pieceOQ = roo?.pieceQuantity ?? 0;
            let otherUnitOQ = roo?.otherUnitQuantity ?? 0;
            let batchCode = roo?.batchCode ?? "";
            
            if (stockBatchWiseMap.has(batchCode)) {
              let [avCs, avPi, avOth] = stockBatchWiseMap.get(batchCode) ?? [0, 0, 0];
              
              let deductCs = Math.min(avCs, caseOQ);
              let deductPi = Math.min(avPi, pieceOQ);
              let deductOth = Math.min(avOth, otherUnitOQ);
              
              stockBatchWiseMap.set(batchCode, [avCs - deductCs, avPi - deductPi, avOth - deductOth]);
            }
          }
        }
        parOrders.push(ro);
      } else {
        // Cannot fulfill at all
        canOrders.push(ro);
      }
    }
    setConfirmableOrders(confOrders);
    setPartiallyConfirmableOrders(parOrders);
    setUnavailableOrders(canOrders);
    pageLoadTrace.stop();
  }

  const getBatchCodeQuantities = (batchCodes: string, batchCodeMap: any): Map<string, [number, number, number]> => {
    let batchCodesArray: string[] = batchCodes ? batchCodes.split(",") : [];
    const result = new Map<string, [number, number, number]>();
    
    batchCodesArray.forEach((bc) => {
        const skuStock = batchCodeMap?.[bc];
        if (!skuStock) {
            // If the batch code doesn't exist in the map, set all quantities to 0
            result.set(bc, [0, 0, 0]);
            return;
        }
        
        let {
            availableCaseQty = 0,
            availablePieceQty = 0,
            availableOtherQty = 0,
            committedCaseQty = 0,
            committedPieceQty = 0,
            committedOtherQty = 0,
        } = skuStock;
        
        let availableStock = {
            cs: availableCaseQty,
            pc: availablePieceQty,
            other: availableOtherQty,
            csComitted: committedCaseQty,
            pcComitted: committedPieceQty,
            otherComitted: committedOtherQty,
        };
        
        // Store the quantities for this batch code in the map
        result.set(bc, [availableStock.cs, availableStock.pc, availableStock.other]);
    });
    
    return result;
  };

  const resetGenericModalProps = () => setGenericModalProps(initialGenericModalProps);

  const handleBulkConfirming = async () => {
      let sendOrderNumbers: string[] = [];
    try {
      // Start a custom trace for manage secondary order bulk confirmation load time
      const pageLoadTrace: PerformanceTrace = trace(performance, "manage_secondary_order_bulk_confirm_handle_confirmation_load_time");
      pageLoadTrace.start();

      setShowProgress({ progress: true, fail: true });

      setBulkConfirmStatusMap({
        ...initialBulkStatusMap,
        pending: checkedOrderNumbers,
      });

      let selectedOrders: bulkConfirmRowsData[] = [];
      for (const ro of data) {
        const orderNumber = ro.orderNumber;
        // NOTE: only use selected rows
        if (!checkedOrderNumbers.includes(orderNumber)) continue;
        selectedOrders.push(ro);
      }
      // let confirmableOrderNumbers: string[] = (disableStockCheck ? selectedOrders : confirmableOrders)?.flatMap(s => s?.orderNumber) ?? [];
      let confirmableOrderNumbers: string[] = (selectedOrders)?.flatMap(s => s?.orderNumber) ?? [];
      let innerOrderStatusMap: Map<string, string> = new Map();

      selectedOrders?.forEach(order => {
          if (order?.orderNumber && order?.status) {
              innerOrderStatusMap.set(order.orderNumber, order.status?.toLowerCase());
          }
      });

      let failedOrderNumbers = disableStockCheck ? [] : unavailableOrders?.flatMap(s => s?.orderNumber) ?? [];
      let total_orders_confirmed: number = 0;
      let total_orders_rejected: number = 0;

      // Process in batches of 30
      setOrderBulkStatusMap((prev: BulkOrderMapType) => ({
        ...prev,
        inProgress: [...prev.inProgress, ...confirmableOrderNumbers],
      }));
      const batchSize = 30;
      for (let i = 0; i < confirmableOrderNumbers.length; i += batchSize) {
        const batch = confirmableOrderNumbers.slice(i, i + batchSize);
        console.log(`Processing batch ${i/batchSize + 1}: ${batch.length} orders`);
        
        const batchResults = await Promise.allSettled(
          batch.map((orderNumber: string) =>
            (async () => {
              try {
                const payload = {
                  status: confirmPayloadStatus.current
                };

                if(failedOrderNumbers?.includes(orderNumber)) {
                  throw new Error("Stock not available");
                }

                // cokearg specific (to make SENT orders PENDING first and then SENT again)
                if(innerOrderStatusMap?.has(orderNumber) && innerOrderStatusMap?.get(orderNumber) === "sent") {
                  let innerPayload = {
                    status: "PENDING"
                  }
                  let _innerResponse = await updateOrderStatus(innerPayload, orderNumber, useNewUpdateStatusAPI)
                }

                const response = await updateOrderStatus(payload, orderNumber, useNewUpdateStatusAPI);

                if (response?.status === 200 || response?.status === 201) {
                  const body = response.data;

                  // Check if the orderDetails array is not empty before accessing the first element
                  const orderDetail = body?.orderDetails?.[0];

                  if (orderDetail?.status === "PARTIALLY CONFIRMED") {
                    setOrderBulkStatusMap((prev: BulkOrderMapType) => ({
                      ...prev,
                      partiallyConfirmed: [...prev.partiallyConfirmed, orderNumber],
                      inProgress: prev.inProgress.filter(order => order !== orderNumber),
                    }));
                  } else {
                    setOrderBulkStatusMap((prev: BulkOrderMapType) => ({
                      ...prev,
                      confirmed: [...prev.confirmed, orderNumber],
                      inProgress: prev.inProgress.filter(order => order !== orderNumber),
                    }));
                  }
                  setOrderNumbers((prev: string[]) => [...prev, orderNumber]);
                  setNonSelectableOrderNumbers((prev: string[]) => [...prev, orderNumber]);
                  return { success: true, isSentOrder: true, orderNumber };
                } else if(response?.status === 206) {
                  setOrderBulkStatusMap((prev: BulkOrderMapType) => ({
                    ...prev,
                    partiallyConfirmed: [...prev.partiallyConfirmed, orderNumber],
                    inProgress: prev.inProgress.filter(order => order !== orderNumber),
                  }));
                  setOrderNumbers((prev: string[]) => [...prev, orderNumber]);
                  setNonSelectableOrderNumbers((prev: string[]) => [...prev, orderNumber]);
                  return { success: true, isSentOrder: false, orderNumber };
                } else {
                  throw new Error("Failed to confirm order");
                }
              } catch (error) {
                console.error(`Error processing order ${orderNumber}: `, error);
                setOrderBulkStatusMap((prev: BulkOrderMapType) => ({
                  ...prev,
                  failed: [...prev.failed, orderNumber],
                  inProgress: prev.inProgress.filter(order => order !== orderNumber),
                }));
                return { success: false, isSentOrder: false, orderNumber };
              } 
            })()
          )
        );
        
        // Count successful and failed orders in this batch
        batchResults.forEach(result => {
          if (result.status === 'fulfilled') {
            const value = result.value;
            if(value.isSentOrder) {
              sendOrderNumbers = [...sendOrderNumbers, value.orderNumber];
            }
            if (value.success) {
              total_orders_confirmed++;
            } else {
              total_orders_rejected++;
            }
          } else {
            total_orders_rejected++;
          }
        });
      }

      logEvent(analytics, "secondary_order_bulk_confirmed", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "total_orders_confirmed": total_orders_confirmed,
      });
      logEvent(analytics, "secondary_order_bulk_rejected", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "total_orders_rejected": total_orders_rejected,
      });

      // Once data is fetched and state is updated, stop the trace
      pageLoadTrace.stop();

    } catch (error) {
      console.error("Error during bulk confirming: ", error);
      setGenericModalProps(
        getGenericModalProps("error", "An error occurred while processing bulk confirming. Please try again.")
      );
    } finally {
      setCheckedOrderNumbers([]);
      setTimeout(() => {
        setShowProgress(showProgressInitialState);
      }, 5000);
      if(showStatusReasonColumnBulkConfirm) await handleApplyLog(sendOrderNumbers);
    }
  };


  const handleUpdateBulkStatus = async (bulkId: string | undefined) => {
    const { newOrderStatusMap, orderInvoiceNumberMap } = await getBulkOpertionData(bulkId);
    console.log("newOrderStatusMap", newOrderStatusMap)
    let isStillInProgress = newOrderStatusMap?.inProgress?.length > 0;
    let confirmed: string[] = newOrderStatusMap?.confirmed || [];
    let partialConfirmed: string[] = newOrderStatusMap?.partiallyConfirmed || [];
    let rejected: string[] = newOrderStatusMap?.rejected || [];
    let invoice: string[] = newOrderStatusMap?.invoiced || [];
    let failed: string[] = newOrderStatusMap?.failed || [];

    let dataOrderNumbers: string[] = [];
    for (const ro of data) {
      let roON = ro?.orderNumber;
      dataOrderNumbers.push(roON);
    }

    // Filter each status array to only include order numbers present in dataOrderNumbers
    newOrderStatusMap.inProgress = (newOrderStatusMap?.inProgress || []).filter(orderNum => dataOrderNumbers.includes(orderNum));
    newOrderStatusMap.confirmed = (newOrderStatusMap?.confirmed || []).filter(orderNum => dataOrderNumbers.includes(orderNum));
    newOrderStatusMap.partiallyConfirmed = (newOrderStatusMap?.partiallyConfirmed || []).filter(orderNum => dataOrderNumbers.includes(orderNum));
    newOrderStatusMap.rejected = (newOrderStatusMap?.rejected || []).filter(orderNum => dataOrderNumbers.includes(orderNum));
    newOrderStatusMap.invoiced = (newOrderStatusMap?.invoiced || []).filter(orderNum => dataOrderNumbers.includes(orderNum));
    newOrderStatusMap.failed = (newOrderStatusMap?.failed || []).filter(orderNum => dataOrderNumbers.includes(orderNum));

    const excluded = new Set([
      ...confirmed,
      ...partialConfirmed,
      ...rejected,
      ...invoice
      ]);
    // Filter `pre` to remove excluded items
    const filtered = checkedOrderNumbers.filter(orderNumber => !excluded.has(orderNumber));

    // Set the new state
    setCheckedOrderNumbers(filtered);
    setOrderBulkStatusMap(newOrderStatusMap);
    setIsBulkStillProcessing(isStillInProgress);

    if(isBulkStillProcessing && !isStillInProgress) {
      setTimeout(() => {
        setShowProgress(showProgressInitialState);
      }, 5000);
    }
  }

  const handleBulkConfirmingNewApproach = async () => {
    try {
      let selectedOrders: bulkConfirmRowsData[] = [];
      for (const ro of data) {
        const orderNumber = ro.orderNumber;
        // NOTE: only use selected rows
        if (!checkedOrderNumbers.includes(orderNumber)) continue;
        selectedOrders.push(ro);
      }
      let confirmableOrderNumbers: string[] = (selectedOrders)?.flatMap(s => s?.orderNumber) ?? [];
      const newOrderStatusMap: BulkOrderMapType = {
        inProgress: [],
        confirmed: [],
        partiallyConfirmed: [],
        rejected: [],
        failed: [],
        invoiced: []
      };
      newOrderStatusMap.inProgress.push(...confirmableOrderNumbers);

      const res = await generateBulkConfirm(confirmableOrderNumbers);
      if (res.status === 208) {
        setOrderBulkStatusMap(orderStatusMap);
        setBulkId(undefined);
        setIsBulkStillProcessing(true);
      } else if(res && res?.data?.bulkId){
        setOrderBulkStatusMap(newOrderStatusMap);
        let bulkId = res?.data?.bulkId;
        setBulkId(bulkId);
        setIsBulkStillProcessing(true);
      }
    } catch (error) {
      console.error("Error during bulk confirming: ", error);
      setGenericModalProps(
        getGenericModalProps("error", "An error occurred while processing bulk confirming. Please try again.")
      );
    } 
  };


  useEffect(() => {
    const { pass, partial, fail, pending, rejected, invoiced } = bulkConfirmStatusMap;

    const updatedRows: bulkConfirmRowsData[] = [...rows]?.map(
      (row: bulkConfirmRowsData) => {
        const orderNumber = row?.orderNumber;
        const status = determineBulkStatus(
          orderNumber,
          pass,
          partial,
          fail,
          pending,
          rejected,
          invoiced,
          row,
          undefined,
          confirmPayloadStatus.current
        );
        return { ...row, status };
      }
    );

    let idsToDisable: string[] = [];

    for (const ro of rows) {
      let roId = ro?.id;
      let roOrderNumber = ro?.orderNumber;
      if (roId && pending.includes(roOrderNumber)) {
        idsToDisable.push(roId);
      }
    }
    setRows(updatedRows);
    setData(updatedRows)
    const total: number =
      (bulkConfirmStatusMap?.fail?.length ?? 0) +
      (bulkConfirmStatusMap?.pass?.length ?? 0) +
      (bulkConfirmStatusMap?.rejected?.length ?? 0) +
      (bulkConfirmStatusMap?.invoiced?.length ?? 0) +
      (bulkConfirmStatusMap?.pending?.length ?? 0) + (bulkConfirmStatusMap?.partial?.length ?? 0);
    if(total > 0) {
      setShowProgress({ progress: true, fail: true });
    }
  }, [bulkConfirmStatusMap]);

  const handleHideProgress = (progressType: string) => {
    setShowProgress({ ...showProgress, [progressType]: false });
  };

  const reset = () => {
    setOrderBulkStatusMap(orderStatusMap);
    setLoader(false);
    setCheckedOrderNumbers([]);
    setBulkConfirmStatusMap(initialBulkStatusMap);
    setShowProgress(showProgressInitialState);
    setNonSelectableOrderNumbers([]);
    setOrderNumbers([])
    setGenericModalProps(initialGenericModalProps)
    setResetSearch(true); 
    setTimeout(() => setResetSearch(false), 0); 
  };
 
  const bulkInvoceInProgress = Boolean(bulkConfirmStatusMap?.pending?.length);

  const showBulkInvoiceProgress = showProgress?.progress || showProgress?.fail;

  const filterOrders = (rowsData: bulkConfirmRowsData[]): void => {
    setRows(rowsData);
    reset();
  };

  useEffect(() => {
  const handleKeyDown = (event: KeyboardEvent) => {
    // Check for ⌘ + A or Ctrl + A
    if ((event.metaKey || event.ctrlKey) && event.key === 'a') {
      event.preventDefault(); // Prevent default browser select-all behavior
      if (checkedOrderNumbers.length > 0) { // Ensure at least one order is selected
        handleClickConfirm();
      } else {
        setGenericModalProps(
          getGenericModalProps("positive", "Please select at least one order to confirm order.")
        );
      }
    }
    // Check for ⌘ + X or Ctrl + X
    if ((event.metaKey || event.ctrlKey) && event.key === 'x') {
      event.preventDefault(); // Prevent default browser cut behavior
      if (handleToggle) { // Ensure handleToggle is defined
        handleToggle();
      }
    }
  };

  // Add event listener for keydown
  document.addEventListener('keydown', handleKeyDown);

  // Cleanup event listener on component unmount
  return () => {
    document.removeEventListener('keydown', handleKeyDown);
  };
}, [checkedOrderNumbers, handleToggle, handleClickConfirm, setGenericModalProps]);

  return (
    <div className="bulk_invoice_parent">
      <ScreenOverlay apply={loader} />
        <CustomBulkModal
          type={genericModalProps?.type}
          message={genericModalProps?.message}
          leftButtonText={genericModalProps?.leftButtonText}
          rightButtonText={genericModalProps?.rightButtonText}
          modalOpen={genericModalProps?.open}
          onLeftButtonClick={genericModalProps?.onLeftButtonClick}
          onRightButtonClick={genericModalProps?.onRightButtonClick}
          onClose={resetGenericModalProps}
          confirmedOrders={confirmableOrders.length ?? 0}
          partiallyConfirmedOrders={partiallyConfirmableOrders.length ?? 0}
          unavailableOrders={unavailableOrders.length ?? 0}
          showSummary={checkedOrderNumbers.length > 0}
          filterConfirmedOrders={() => filterOrders(confirmableOrders)}
          filterPartiallyConfirmedOrders={() => filterOrders(partiallyConfirmableOrders)}
          filterUnavailableOrders={() => filterOrders(unavailableOrders)}
        />

      {showBulkInvoiceProgress && (
        <BulkProgress
          type={ bulkType }
          bulkStatusMap={orderBulkStatusMap}
          showProgress={showProgress}
          handleHideProgress={handleHideProgress}
        />
      )}

      <Snackbar
        open={snackbarOpen}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="info"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Your report will be downloaded shortly.
        </Alert>
      </Snackbar>

      <Header
        title={bulkConfirmLabelConfig.pageHeadingLabel}
        searchFunction={handleSearchValueChange}
        onRefresh={init}
        resetSearch={resetSearch}
      />

      <div className="dms_toolbar">
        <div className="bulk_invoice_support_utility_dates">
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            className="manage_order_dateEnter"
          >
            <DatePicker
              label="From Date"
              inputFormat="DD-MM-YYYY"
              value={startDate}
              maxDate={dayjs()}
              onChange={(value) => {
                if (value) {
                  setStartDate(value);
                }
              }}
              renderInput={(props) => (
                <TextField {...props} inputProps={{
                  ...props.inputProps,
                  readOnly: true,
                }} disabled size="small" />
              )}
            />
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="To Date"
              inputFormat="DD-MM-YYYY"
              value={endDate}
              maxDate={dayjs()}
              onChange={(value) => {
                if (value) {
                  setEndDate(value);
                }
              }}
              renderInput={(props) => (
                <TextField {...props} inputProps={{
                  ...props.inputProps,
                  readOnly: true,
                }} disabled size="small" />
              )}
            />
          </LocalizationProvider>
          <Button
            variant="contained"
            sx={{
              textTransform: "none",
              backgroundColor: "#237C9D",
              boxShadow: "none",
              "&:hover": {
                boxShadow: "none",
              },
            }}
            onClick={() => handleApplyLog()}
          >
            Apply
          </Button>
          <Button
            variant="outlined"
            sx={{
              textTransform: "none",
              backgroundColor: "#f0fbff",
              boxShadow: "none",
              "&:hover": {
                boxShadow: "none",
              },
            }}
            onClick={handleClearAllLog}
          >
            Reset
          </Button>
        </div>

        {multipleCategoryFilterEnabled && showFilterInBulkConfirm.current && <FormControl className="manage_secondary_orders_filter">
          <span style={{ fontSize: "14px", color: "#6E6969" }}>Filter:</span>
          <Select
            variant="outlined"
            labelId="dropdown_label"
            open={multipleFiltersVisible}
            value="Filter Orders"
            onOpen={() => {
              setMultipleFiltersVisible(true);
              setFilterSearchValue("");
            }}
            onClose={() => setMultipleFiltersVisible(false)}
            renderValue={() => (
              <span style={{ color: "#909090", fontSize: "14px" }}>
                Filter Orders
              </span>
            )}
            sx={{
              border: Object.values(selectedFilters)?.some(arr => arr?.length > 0)
                ? "1px solid var(--dashboard-theme-color)"
                : "1px solid #ccc",
              boxSizing: "border-box",
              height: "37px",
              minWidth: "190px",
              marginLeft: "10px",
              "& .MuiSelect-select": {
                height: "32px",
                padding: "6px 12px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                color: "#909090",
                outline: "none",
                border: "none",
              },
              "& .MuiOutlinedInput-root.Mui-focused": {
                outline: "none",
                boxShadow: "none",
              },

              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#DEDEDE",
                borderWidth: "1px",
              },

              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#DEDEDE",
              },

              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#DEDEDE",
                borderWidth: "1px",
              },
            }}
            MenuProps={{
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "right",
              },
              PaperProps: {
                sx: {
                  boxShadow: "none",
                  marginTop: "4px",
                  border: "1px solid #DEDEDE",
                },
              },
              MenuListProps: {
                sx: {
                  paddingTop: "8px",
                  paddingBottom: "0",
                },
              },
            }}
          >
            <MenuItem
              key={`filter-${selectedFilterType}-${JSON.stringify(selectedFilters)}`}
              disableRipple
              style={{
                padding: 0,
                backgroundColor: "transparent",
                outline: "none",
              }}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <div className="MSO_filter-dropdown-container"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="MSO_filter-header">
                  <span className="MSO_filter-name">All Filters</span>
                  <span
                    className={`MSO_filter-clear-all ${
                      (Object.values(selectedFilters).some((arr) => arr.length > 0) || 
                        filterSearchValue) &&
                      `MSO_filter-clear-all_active`
                    }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedFilters({});
                      setFilterSearchValue("");
                      // Clear URL parameters when clearing all filters
                    }}
                  >
                    Clear All
                  </span>
                </div>
                <div className="MSO_filter_searchBar_container">
                  <div></div>
                  <input
                    className="MSO_fiter_searchBar"
                    placeholder="Search..."
                    value={filterSearchValue}
                    onClick={(e) => e.stopPropagation()}
                    onChange={handleFilterSearchValueChange}
                    autoFocus
                    onBlur={(e) => e.target.focus()}
                  />
                </div>

                <div className="MSO_filter-options">
                  <div className="MSO_filter-options-left">
                    {filterKeys.map((key) => (
                      <div
                        key={key}
                        className={`${selectedFilterType === key && `MSO_filterSelected`}`}
                        onClick={(e) => {
                          handleFilterTypeChange(key);
                          e.stopPropagation();
                        }}
                      >
                        {getFilterLabel(key)} ({(selectedFilters[key] || []).length})
                      </div>
                    ))}
                  </div>
                  <div className="MSO_filter-options-right">
                    {filterKeys.map(
                      (key) =>
                        selectedFilterType === key && (
                          <SimpleBar className="MSO_filter-option-secondary" key={key}>
                            {Object.keys(multipleFiltersList[key] ?? {})
                              .filter((value) =>
                                filterSearchValue && typeof value === "string"
                                  ? value.toLowerCase().includes(filterSearchValue.toLowerCase())
                                  : true
                              )
                              .map((value) => (
                                <label
                                  key={value}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    color: "#444444",
                                    fontSize: "13px",
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <input
                                    type="checkbox"
                                    checked={(selectedFilters[key] || []).includes(value)}
                                    onChange={() => handleSelectedFilterChange(key, value)}
                                    style={{ borderColor: "#CBCBCB" }}
                                  />
                                  {key === "source" ? (
                                      `${value.toUpperCase()} (${multipleFiltersList[key]?.[value] || 0})`
                                    ) : (key === "salesRepName" || key === "routeIdAndName") ? (
                                      <Tooltip title={value} arrow>
                                        <span>{`${capitalizeFirstLetter(truncateString(value,20))} (${multipleFiltersList[key]?.[value] || 0})`}</span>
                                      </Tooltip>
                                    ) : key === "gstNo" ? (
                                      `${value.toLowerCase().includes("non") ? "Non-GST Outlet" : "GST Outlet"} (${multipleFiltersList[key]?.[value] || 0})`
                                    ) : (
                                      <Tooltip title={value} arrow>
                                        <span>{`${capitalizeFirstLetter(value)} (${multipleFiltersList[key]?.[value] || 0})`}</span>
                                      </Tooltip>
                                    )}
                                </label>
                              ))}
                          </SimpleBar>
                        )
                    )}
                  </div>
                </div>
              </div>
            </MenuItem>
          </Select>
        </FormControl>}
   
      </div>

      {loader ? (
        <Loader sx={{ position: "absolute", top: "55%" }} />
      ) : (
        <CustomDataGrid
          rows={Array.isArray(rows) ? rows : []}
          columnsMetaData={bulkConfirmColumnsMetaData()}
          orderStatusConfig={orderTrackingStagesList}
          redirectUrl="/sale/manageOrders/viewOrder/"
          tableWidth={0.723}
          isCheckboxSelection={true}
          setCheckedIdArray={handleSetCheckedIdArray}
          downloadSingleReportConfig={downloadSingleReportConfig}
          handleClickBulk={handleClickConfirm}
          bulkType={bulkType}
          footerButtonLoading={bulkInvoceInProgress}
          checkedIdArray={checkedOrderNumbers}
          disabledRowIds={[...(bulkConfirmStatusMap?.pending || []), ...disableRowIds]}
          rowIdsWithCheckboxHidden={nonSelectableOrderNumbers}
          handleBulkNav={handleToggle}
          isBulkOrderConfirmAllowedFromBC={true}
          isAnyPendingOrder = {true}
        />
      )}
    </div>
  );
};

export default BulkConfirm;
